import React from "react";
import { Switch as HeadlessSwitch } from "@headlessui/react";
import classNames from "classnames";

type ToggleOption = () => React.ReactNode;

interface TextToggleProps {
  // * This single label is used for a11y, since switches
  // * function similar to checkboxes in screen readers
  ariaLabel: string;
  enabled: boolean;
  // * Option 1 is the content for the left hand side of toggle
  renderOption1: ToggleOption;
  // * Option 2 is the content for the left hand side of toggle
  renderOption2: ToggleOption;
  onChange?: (enabled: boolean) => void;
}

const TextToggle: React.FC<TextToggleProps> = ({
  ariaLabel,
  enabled,
  onChange = () => {},
  renderOption1,
  renderOption2,
}) => (
  <HeadlessSwitch.Group>
    <HeadlessSwitch
      aria-label={ariaLabel}
      checked={enabled}
      onChange={onChange}
      className={classNames(
        "relative inline-flex flex-shrink-0 h-12 w-full bg-grey-44 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200"
      )}
    >
      <span
        className={classNames(
          enabled ? "translate-x-full" : "translate-x-0",
          "pointer-events-none absolute inline-block h-11 w-1/2 bg-default border-2 border-grey-44 rounded-full transform transition ease-in-out duration-200"
        )}
      ></span>
      <div className="grid grid-cols-2 w-full h-full items-center cursor-pointer">
        <div className="text-sm z-40">
          <div
            className={classNames(
              { "text-default": enabled, "text-white": !enabled },
              "flex items-center justify-center font-bold text-xs w-full cursor-pointer transition-colors ease-in-out duration-200"
            )}
          >
            {renderOption1()}
          </div>
        </div>
        <div className="text-sm z-40">
          <div
            className={classNames(
              { "text-default": !enabled, "text-white": enabled },
              "flex items-center justify-center font-bold text-xs w-full cursor-pointer transition-colors ease-in-out duration-200"
            )}
          >
            {renderOption2()}
          </div>
        </div>
      </div>
    </HeadlessSwitch>
  </HeadlessSwitch.Group>
);

export default TextToggle;
